import { render, staticRenderFns } from "./DappCard.vue?vue&type=template&id=aa37d55e&scoped=true"
import script from "./DappCard.vue?vue&type=script&lang=ts"
export * from "./DappCard.vue?vue&type=script&lang=ts"
import style0 from "./DappCard.vue?vue&type=style&index=0&id=aa37d55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa37d55e",
  null
  
)

export default component.exports